import { useMutation } from '@apollo/client'
import { GENERATE_DOWNLOAD_LINK } from '../data/generate-download-link'
import {
  GenerateDownloadLinkMutationMutation,
  GenerateDownloadLinkMutationMutationVariables
} from '@/core/types/graphql'

export const useGenerateDownloadLink = () => {
  const [generateDownloadLink] = useMutation<
    GenerateDownloadLinkMutationMutation,
    GenerateDownloadLinkMutationMutationVariables
  >(GENERATE_DOWNLOAD_LINK)

  return {
    generateDownloadLink
  }
}
